// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/dialogs/components/ComparisonRow.module.css';
import {observer} from 'mobx-react-lite';
import type React from 'react';

export const ComparisonRow = observer(
	({
		feature,
		freeValue,
		plutoniumValue,
	}: {
		feature: string;
		freeValue: React.ReactNode;
		plutoniumValue: React.ReactNode;
	}) => (
		<div className={styles.row} data-flx="app.comparison-row.row">
			<div className={styles.feature} data-flx="app.comparison-row.feature">
				<p className={styles.featureText} data-flx="app.comparison-row.feature-text">
					{feature}
				</p>
			</div>
			<div className={styles.valuesContainer} data-flx="app.comparison-row.values-container">
				<div className={styles.freeValue} data-flx="app.comparison-row.free-value">
					{freeValue}
				</div>
				<div className={styles.plutoniumValue} data-flx="app.comparison-row.plutonium-value">
					{plutoniumValue}
				</div>
			</div>
		</div>
	),
);
